<div class="st-drawer-wrapper master-form-drawer flex flex-column">
  <a href=""></a>
  <div class="st-drawer-header show-border flex-center-between">
    <span class="text-header-16 text-semibold">Crear {{ nzData.maestroName }}</span>
    <app-st-icon (click)="close()" class="text-header-16 cursor-pointer" [name]="'close'" [bold]="true"></app-st-icon>
  </div>

  <form [formGroup]="dynamicForm" class="st-drawer-content st-form" nz-form>
    <div *ngFor="let column of nzData.columnsData">
      @if (column.pathData && column.pathData.name !== 'id') {
        <div [ngSwitch]="column.pathData.type || 'text'">
          <div *ngSwitchCase="'text'">
            <nz-form-item>
              <nz-form-label [nzSpan]="24" [nzRequired]="!!column.validators?.length">{{ column.name }}</nz-form-label>
              <nz-form-control [nzErrorTip]="getValidatorError(column)" nzHasFeedback>
                <input type="text" nzSize="large" nz-input [formControlName]="column.pathData.name" />
              </nz-form-control>
            </nz-form-item>
          </div>

          <div *ngSwitchCase="'number'">
            <nz-form-item>
              <nz-form-label [nzSpan]="24" [nzRequired]="!!column.validators?.length">{{ column.name }}</nz-form-label>
              <nz-form-control [nzErrorTip]="getValidatorError(column)" nzHasFeedback>
                <input type="number" nzSize="large" nz-input [formControlName]="column.pathData.name" />
              </nz-form-control>
            </nz-form-item>
          </div>

          <div *ngSwitchCase="'select'">
            <nz-form-item>
              <nz-form-label [nzSpan]="24" [nzRequired]="isRequired(column)">{{ column.name }}</nz-form-label>
              <nz-form-control
                [nzErrorTip]="hasOptions(column) ? 'Este campo es requerido' : 'No hay opciones disponibles'"
                nzHasFeedback>
                @if (hasOptions(column)) {
                <nz-select nzSize="large" nzShowSearch [formControlName]="column.pathData.name">
                  <nz-option *ngFor="let opt of column.optionList || []" [nzValue]="opt.id" [nzLabel]="opt.name || opt.role"></nz-option>
                </nz-select>
                } @else {
                <nz-select nzSize="large" [nzDisabled]="true" [formControlName]="column.pathData.name" nzPlaceHolder="No hay opciones disponibles">
                  <nz-option nzValue="" nzLabel="No hay opciones disponibles" nzDisabled></nz-option>
                </nz-select>
                <div class="text-label-12 color-grey-9 option-hint">Este campo requiere opciones del maestro.</div>
                }
              </nz-form-control>
            </nz-form-item>
          </div>

          <div *ngSwitchCase="'boolean'">
            <nz-form-item>
              <nz-form-label [nzSpan]="24">{{ column.name }}</nz-form-label>
              <nz-form-control>
                <nz-select nzSize="large" [formControlName]="column.pathData.name">
                  <nz-option [nzValue]="true" nzLabel="Si"></nz-option>
                  <nz-option [nzValue]="false" nzLabel="No"></nz-option>
                </nz-select>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>
      }
    </div>
  </form>

  <div class="st-drawer-footer show-border flex-center-between">
    <button nz-button class="text-btn-14" nzType="text" nzShape="round" nzSize="large" (click)="close()">
      <span>Descartar</span>
    </button>
    <button nz-button nzType="primary" nzShape="round" nzSize="large" [disabled]="dynamicForm.invalid" (click)="create()">
      <span>Crear</span>
    </button>
  </div>
</div>
